import './App.css';
import React, {Component} from 'react'
import  { CardList } from './components/card-list/card-list.component'
import { SearchBox } from './components/search-box/search-box.component';

class App extends Component {
  constructor() {
    super();

    this.state = {
      cats: [],
      searchField: ''
    }
  }

  componentDidMount() {
    fetch('https://jsonplaceholder.typicode.com/users')
    .then(response => response.json())//the response that we get from the promise in JSON 
    //users is a parameter of that response 
    .then(users => this.setState({cats: users})) 
  }

  handleChange = (e) => {
    this.setState({searchField: e.target.value})
  } 

  render() {

    const { cats, searchField} = this.state;
    const filteredCats = cats.filter(cat => 
      cat.name.toLowerCase().includes(searchField.toLowerCase())
      )

    return (
          <div className="App">
          {/* <input type="search"
          placeholder="search monsters"
          onChange={e => this.setState({searchField: e.target.value})}
          /> 
          type is already on our searchbox component
          */}
          <h1>Meow Meow</h1>
            <SearchBox placeholder="search cats" handleChange={this.handleChange}/>
            <CardList cats={filteredCats}/> 
          </div> 
    )
  }
}

export default App;
